import axios from "axios"
import { SEARCH_LANDING_PAGES } from "src/constants"

export const searchLandingPages = async (query) => {
    return await axios.get(`${SEARCH_LANDING_PAGES}`, {
        params: { query }
    })
}